import useFeatureFlag from '@/components/hooks/useFeatureFlag';
import { CLIENT_FEATURE_FLAGS } from '@/constants';

function useIsEarlyPremiumIntro() {
  const daycareEarlyPremiumIntroFlag = useFeatureFlag(
    CLIENT_FEATURE_FLAGS.DAYCARE_ENROLLMENT_EARLY_PREMIUM_INTRO_FLOW
  );

  const isEarlyPremiumIntroEnabled = daycareEarlyPremiumIntroFlag?.value === 1;

  const isEarlyPremiumIntroFlow = isEarlyPremiumIntroEnabled;

  return {
    isEarlyPremiumIntroFlow,
    isEarlyPremiumIntroEnabled,
    daycareEarlyPremiumIntroFlag,
  };
}

export default useIsEarlyPremiumIntro;
